import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {
      avatarurl: ''
    },
    lastKingRank: [],
    thisKingRank: [],
    lastKingMyRank: {},
    thisKingMyRank: {},

    lastRoomRank: [],
    thisRoomRank: [],
    lastRoomMyRank: {},
    thisRoomMyRank: {},

    lastSupporterRank: [],
    thisSupporterRank: [],
    lastSupporterMyRank: {},
    thisSupporterMyRank: {},

    pkCD: null,
    remaintime: null,

    shuju: [],
    historyList: []
  }
  @action async GetUserInfoWeb() {
    this.data.notNetwork = false
    let d = await http.post('/web/MyAccountInfo', {})
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
    } else {
      this.data.notNetwork = true
    }
  }

  // king
  @action async GetKingRank() {
    this.data.notNetwork = false
    let lastKingRank = await http.post('/web/pk/king/rank', { daysago: 7 })
    let thisKingRank = await http.post('/web/pk/king/rank', { daysago: 0 })
    this.data.lastKingRank = (lastKingRank && lastKingRank.res && lastKingRank.res.list) || []
    this.data.thisKingRank = (thisKingRank && thisKingRank.res && thisKingRank.res.list) || []
    this.data.lastKingMyRank = (lastKingRank && lastKingRank.res && lastKingRank.res.myrank) || {}
    this.data.thisKingMyRank = (thisKingRank && thisKingRank.res && thisKingRank.res.myrank) || {}
  }

  // room
  @action async GetRoomRank() {
    this.data.notNetwork = false
    let lastRoomRank = await http.post('/web/pk/room/rank', { daysago: 7 })
    let thisRoomRank = await http.post('/web/pk/room/rank', { daysago: 0 })
    this.data.lastRoomRank = (lastRoomRank && lastRoomRank.res && lastRoomRank.res.list) || []
    this.data.thisRoomRank = (thisRoomRank && thisRoomRank.res && thisRoomRank.res.list) || []
    this.data.lastRoomMyRank = (lastRoomRank && lastRoomRank.res && lastRoomRank.res.myrank) || {}
    this.data.thisRoomMyRank = (thisRoomRank && thisRoomRank.res && thisRoomRank.res.myrank) || {}
  }
  // supporter
  @action async GetSupporterRank() {
    this.data.notNetwork = false
    let lastSupporterRank = await http.post('/web/pk/booster/rank', { daysago: 7 })
    let thisSupporterRank = await http.post('/web/pk/booster/rank', { daysago: 0 })
    this.data.lastSupporterRank = (lastSupporterRank && lastSupporterRank.res && lastSupporterRank.res.list) || []
    this.data.thisSupporterRank = (thisSupporterRank && thisSupporterRank.res && thisSupporterRank.res.list) || []
    this.data.lastSupporterMyRank = (lastSupporterRank && lastSupporterRank.res && lastSupporterRank.res.myrank) || {}
    this.data.thisSupporterMyRank = (thisSupporterRank && thisSupporterRank.res && thisSupporterRank.res.myrank) || {}
  }

  // pkCountDown
  @action async pkCountDown() {
    this.data.notNetwork = false
    let pkCD = await http.post('/web/pk/count/down')
    if (pkCD.code == 0) {
      // this.data.now = d.res.now
      let ts = pkCD.res
      if (ts > 0) {
        this.data.remaintime = ts
      }
    }
  }
  @action async hitoryTop() {
    this.data.notNetwork = false
    let hitory = await http.post('/web/pk/history/top1')
    this.data.historyList = (hitory && hitory.res) || []
  }
}



// WEBPACK FOOTER //
// src/store/activity/pk.js